import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, consultarTipoModificacaoAlteracao } from './types';

export const INITIAL_STATE: consultarTipoModificacaoAlteracao = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultarTipoModificacaoAlteracao {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_TIPO_MODIFICACAO_ALTERACAO_REQUEST: {
				break;
			}
			case Types.CONSULTA_TIPO_MODIFICACAO_ALTERACAO_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload.tiposModificacao;
				break;
			}
			case Types.CONSULTA_TIPO_MODIFICACAO_ALTERACAO_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.CONSULTA_TIPO_MODIFICACAO_ALTERACAO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
